import { Box, Heading, Stack, Text } from 'braid-design-system';

import { SnapCarousel } from 'src/components/SnapCarousel';

import * as styles from './CustomerStatement.css';

interface Testimonial {
  quote: string;
  name: string;
  business: string;
}

const testimonials: Testimonial[] = [
  {
    quote:
      'Plenty of people just close the doors. I wanted better than that. I listed only on SEEK Business, took my time and found the right buyer.',
    name: 'Barry',
    business: 'Newcastle Security Doors and Screens',
  },
  {
    quote:
      'The flexibility to update my ad and pricing at any time – and the ability to act fast on enquiries – made all the difference.',
    name: 'Carli',
    business: 'SQS Safety & Quality Solution',
  },
  {
    quote:
      "Free to list and simpler than I ever imagined. I couldn't recommend it highly enough.",
    name: 'David',
    business: 'You Know Who',
  },
  {
    quote:
      "I've sold three businesses myself and learned a lot along the way. Ultimately, you're the best salesperson for your own business – and SEEK Business gave me what I needed to do it.",
    name: 'Simon',
    business: "Lily's Cafe",
  },
  {
    quote:
      "I have some good news. We've sold our business! As it happens the buyer was one of the first to enquire. I wanted to thank you very much for all of your help with our advertisement... We can now retire and replace work with pleasure. Thanks again!",
    name: 'Pauline',
    business: 'Lab Racks',
  },
];

// Braid has no quote icon
const QuoteMark = () => (
  <svg
    aria-hidden
    className={styles.quoteMark}
    width="20"
    height="15"
    viewBox="0 0 32 24"
    fill="currentColor"
  >
    <path d="M0 24V14.4C0 6.4 4.27 1.6 12.8 0l1.6 3.2C9.6 4.53 7.2 7.2 7.2 11.2H12.8V24H0Zm17.6 0V14.4C17.6 6.4 21.87 1.6 30.4 0L32 3.2c-4.8 1.33-7.2 4-7.2 8h5.6V24H17.6Z" />
  </svg>
);

const maxCardsShown = (count: number) => ({
  mobile: Math.min(count, 1),
  tablet: Math.min(count, 2),
  desktop: Math.min(count, 3),
  wide: Math.min(count, 3),
});

export const CustomerStatement = () => (
  <Stack space="large">
    <Heading level="2" align="center">
      Why business owners choose us
    </Heading>

    <SnapCarousel
      show={maxCardsShown(testimonials.length)}
      label="Customer testimonials"
    >
      {testimonials.map((testimonial) => (
        <Box
          key={testimonial.name}
          background="surface"
          borderRadius="xlarge"
          padding="large"
          height="full"
          className={styles.card}
          data={{ testid: 'packages-testimonial-card' }}
        >
          <Stack space="large">
            <Stack space="small">
              <QuoteMark />
              <Text>{testimonial.quote}</Text>
            </Stack>

            <Text weight="strong">
              {testimonial.name}, {testimonial.business}
            </Text>
          </Stack>
        </Box>
      ))}
    </SnapCarousel>
  </Stack>
);
